/** Human file size. One implementation — BugReportModal, ClientView and Scheduled all
 *  rendered their own, and only one of the three ever switched to MB. */
export function formatFileSize(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) return '';
  if (bytes < 1024) return `${Math.round(bytes)} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/** A calendar day in the VIEWER's timezone, `YYYY-MM-DD`.
 *  ⚠️ NOT `toISOString().slice(0,10)` — that is the UTC day, which is a different date for
 *  ~30% of the day outside UTC (late west of it, early east of it). The server stores
 *  follow-ups as bare days, so what gets written must be the day the user means. */
export function localDay(d: Date = new Date()): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/** Parse a bare `YYYY-MM-DD` as LOCAL midnight; pass anything else through.
 *  ⚠️ `new Date('2026-04-11')` is UTC midnight and renders as the previous day west of
 *  UTC. Appending a time makes it local. (Noon works too — see ScoreChart.) */
export function parseDay(dateStr: string): Date {
  return new Date(/^\d{4}-\d{2}-\d{2}$/.test(dateStr) ? `${dateStr}T00:00` : dateStr);
}

/** Whole calendar days between a `YYYY-MM-DD` and today, both in the viewer's zone. */
export function daysSince(dateStr: string): number {
  const then = parseDay(dateStr);
  const now = new Date();
  then.setHours(0, 0, 0, 0);
  now.setHours(0, 0, 0, 0);
  return Math.round((now.getTime() - then.getTime()) / 86400000);
}
